module.exports = __webpack_public_path__ + "img/1270.a05bd508.gif";